import { Component, OnInit } from '@angular/core';
import { UserAuthService } from './services/user-auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { ApiService } from './services/api.service';
import { IDatasets } from './interfaces/i-datasets';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'gem-hd-portal';
  public datasets: IDatasets[] = [];
  public error: HttpErrorResponse | undefined;
  public currentDataset: string | undefined;

  constructor(
    public router: Router,
    private auth: UserAuthService,
    private api: ApiService,
    public spinner: NgxSpinnerService) {}

  ngOnInit() {
    // Subscribe to router events to update currentDataset when navigating to GWAS 1-6 pages
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      if (this.isGwas16DisplayPage()) {
        // Extract dataset name from URL for gwas-16/display/:id
        const urlParts = this.router.url.split('/');
        if (urlParts.length >= 4 && urlParts[1] === 'gwas-16' && urlParts[2] === 'display') {
          this.currentDataset = urlParts[3];
        }
      }
      
      // Load datasets only when on GWAS 1-6 display pages (not on initial selection)
      if (this.isGwas16DisplayPage()) {
        this.loadDatasets();
      }
    });

    // Initial load if already on GWAS 1-6 display page
    if (this.isGwas16DisplayPage()) {
      this.loadDatasets();
    }
  }

  login() {
    this.auth.init();
  }

  logout() {
    this.auth.logout();
  }

  isLoggedIn(): boolean {
    return this.auth.loggedIn();
  }

  isGwas16Page(): boolean {
    return this.router.url.startsWith('/gwas-16');
  }

  isGwas16DisplayPage(): boolean {
    return this.router.url.startsWith('/gwas-16/display/');
  }

  isPanelIframePage(): boolean {
    return this.router.url.startsWith('/gwas-15') || this.router.url.startsWith('/gwas-16/display/');
  }

  loadDatasets() {
    this.spinner.show();
    this.api.getGRCh38Datasets().subscribe({
      next: (result) => {
        this.datasets = result;
        this.spinner.hide();
      },
      error: (err: HttpErrorResponse) => {
        this.error = err;
        this.spinner.hide();
      },
    });
  }

  changeDataset(datasetName: string) {
    // Navigate to the new URL and force a page reload
    window.location.href = '/gwas-16/display/' + datasetName;
    this.currentDataset = datasetName;
  }
}
